import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";

import exmark from "../../exmark.png";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import InputInteger from "../../helpers/InputInteger";
import InputCombo from "../../helpers/InputCombo";
import ItcList from "./ItcList";
 




function Itc(props)
{

    var fak_kontrahenci_id = -1;
    if(props.fak_kontrahenci_id != undefined ) fak_kontrahenci_id = props.fak_kontrahenci_id;

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({    
        fak_kontrahenci_id:  props.mainView.readFilter('fak_kontrahenci_id', fak_kontrahenci_id),        
        klient_nazwa:  props.mainView.readFilter('klient_nazwa',''),        
        accountcode:  props.mainView.readFilter('accountcode',''),        
        nr_infolinii:  props.mainView.readFilter('nr_infolinii',''),        
        usluga_aktywna:  props.mainView.readFilter('usluga_aktywna',-1),        
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

  
 

    const [view, setView] = useState ({["v"]:"list", ["id"]:-1});

    const [legend, setLegend] = useState([
        
         {
            cls:'color_show4',
            title: 'domyślny cennik',
            filter: {  filed: "domyslny", set: "TAK", typ: "combo"  },
        },
    ]);


 


      const [nParam, setNParam] = useState('');  

      const paramListener = (filedName, val, correct, msg) => { 
               setNParam(val);
      }




        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {
 
            props.mainView.writeFilter('klient_nazwa', '');
            props.mainView.writeFilter('fak_kontrahenci_id', fak_kontrahenci_id);
            props.mainView.writeFilter('accountcode', '');
            props.mainView.writeFilter('nr_infolinii', '');
            props.mainView.writeFilter('usluga_aktywna', -1);
    
           

            setFilterParam({                    
                klient_nazwa: '',                 
                fak_kontrahenci_id: fak_kontrahenci_id,                                              
                accountcode: '',                                              
                nr_infolinii: '',                                              
                usluga_aktywna: -1,                                              
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_info,itc', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }


 

    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');
            setView({...view, ["v"]:v, ["id"]:id });
    }

  


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }

    

    const addNewPrice = () => {

          if(nParam.length < 2)
          {
            return;
          }

          props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_info,pricelist_add', {
                                            method: 'POST', 
                                            body: JSON.stringify( { nazwa: nParam}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         setTab(null);                                                                           
                                                         setNParam('');
                                                         setView({...view, ["v"]:"list", ["id"]:-1 });  
                                                         
                                                         props.mainView.showDialog( "Sukces", "Cennik został dodany." , "ok" , null);                                                                       
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });

    }



    const removePrice = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz usunąć wybrany cennik ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_info,pricelist_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Cennik został usunięty"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można usunać cennika " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );




    }


    const changeViewTab = (e) => {

        if(view.v == 'list')
        {
            setView({["v"]:"list2", ["id"]:-1 } );
        }else 
        {
            setView({["v"]:"list", ["id"]:-1 } ); 
        }
    }



   const keyListener = (e) => {
                       var code = e.keyCode ? e.keyCode : e.which;    

                        if( code == 27 && view.v == 'new' )                                                  
                        {
                                  setView({...view, ["v"]:'list', ["id"]:'-1' });    
                        }else                             
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                                setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }
   }

   useEffect( ()=>{

            if(Config.env == "dev") console.log("Itc.js, listener on");
            window.onkeydown = keyListener; 

            return () => {   
                 if(Config.env == "dev") console.log("Itc.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );







    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);    
    }



    if(tab == null)
    {
        setTab([]);
        getTab();     
        return <div>
            ...
        </div>
    }





    var dialogX = null;


 

 
        var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "nazwa", name: "Nazwa"  },
]

    document.title = "ITC";
    var titleRaport = "ITC";

    return  <div className="view_content">

            
                <h3 className="dash_header">ITC</h3>

    
               <div className="table_filter">

                        <div className="filter_controll">   
                                <label>Klient: </label>                             
                                <InputText   userData={props.userData} value={filterParam.klient_nazwa}   valChange={valChangeListener} goNext={goNextNew} name="klient_nazwa" placeholder={"Klienta: "}   />
                        </div> 
 
                        <div className="filter_controll">   
                                <label>AccountCode: </label>                             
                                <InputText   userData={props.userData} value={filterParam.accountcode}   valChange={valChangeListener} goNext={goNextNew} name="accountcode" placeholder={"AccountCode: "}   />
                        </div> 
 
                        <div className="filter_controll">   
                                <label>Nr info.: </label>                             
                                <InputText   userData={props.userData} value={filterParam.nr_infolinii}   valChange={valChangeListener} goNext={goNextNew} name="nr_infolinii" placeholder={"Nr info.: "}   />
                        </div> 


                        <div className="filter_controll">   
                                <label>Stan usługi: </label>                             
                                <InputCombo items={ [{v:-1,title:' --- '},  {v:0,title:'Nie'},  {v:1,title:'Tak'},    ] }   userData={props.userData} value={filterParam.usluga_aktywna}   valChange={valChangeListener} goNext={goNextNew} name="usluga_aktywna" placeholder={": "}   />
                        </div> 

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                          
                            
                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                              &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />
                                    <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  

                                    &nbsp;
                                    &nbsp;
                                    <span className="link_color" onClick={changeViewTab}>zmień widok</span> 
                </div>


               <div className="bg_center">


                        <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3> 
                            <table className="table" ref={tab2Ref}  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                         
                                                <td>Nazwa</td>                                                                                                                                    
                                                <td className="td_right">Ilość aktywnych</td>                                                                                      
                                                                                                                          
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(  row.domyslny == "TAK" )
                                                            {
                                                                rowStyle += " color_show4 " ;
                                                            }
 
                                                            var act = 0;

                                                            for(var xx =0 ; xx < row.list.length; xx++)
                                                            {
                                                                if(row.list[xx].usluga_aktywna == '1') act++;
                                                            }

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                              
                                                                                                                     
                                                                <td v="review" id={row.id}   onClick={changeView}>{row.nazwa}</td>
                                                                <td className="gocenter">{act}</td>
                                                                
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>
                        </div>

                    {
                        view.v == 'list' && 
                          <table className="table"  >

                                    <thead>
                                        <tr className="header">                                                                                               
                                            <td className="td_left">LP</td>                                                                                                                                                                         
                                            <td>Nazwa</td>                                                                                                                                    
                                            <td>Infolinie</td>                                                                                                                                    
                                            <td className="td_right">Aktywnych</td>                                                                                      
                                                                                                                            
                                        </tr>
                                    </thead>

                                    <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                        if(  row.domyslny == "TAK" )
                                                        {
                                                            rowStyle += " color_show4 " ;
                                                        }


                                                            var act = 0;

                                                        for(var xx =0 ; xx < row.list.length; xx++)
                                                        {
                                                            if(row.list[xx].usluga_aktywna == '1') act++;
                                                        }


                                                        return <tr className={rowStyle} key={ix}>
                                                            <td className="gocenter">{ix+1}</td>                                                              
                                                                                                                    
                                                            <td v="review" id={row.id}   onClick={changeView}>{row.nazwa}</td>
                                                            <td className="gocenter"> <ItcList tab={row.list} /> </td>
                                                            <td className="gocenter">{act}</td>
                                                            
                                                    
                                                        </tr>

                                                } )
                                            }

                                    </tbody>

                            </table>
                    }


                     {
                        view.v == 'list2' && 
                          <table className="table"  >

                                    <thead>
                                        <tr className="header">                                                                                               
                                            <td className="td_left">LP</td>                                                                                                                                                                         
                                            <td>Nazwa</td>                                                                                                                                    
                                            <td>Infolinie</td>                                                                                                                                    
                                            <td className="td_right">Aktywnych</td>                                                                                      
                                                                                                                            
                                        </tr>
                                    </thead>

                                    <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                        if(  row.domyslny == "TAK" )
                                                        {
                                                            rowStyle += " color_show4 " ;
                                                        }


                                                            var act = 0;


                                                        for(var xx =0 ; xx < row.list.length; xx++)
                                                        {
                                                            if(row.list[xx].usluga_aktywna == '1') act++;
                                                        }


                                                        return <tr className={rowStyle} key={ix}>
                                                            <td className="gocenter">{ix+1}</td>                                                              
                                                                                                                    
                                                            <td v="review" id={row.id}    >{row.nazwa}</td>
                                                            <td className="gocenter"> 
                                                                {
                                                                    row.list.map((num, inxx) => {

                                                                        if(num.numer_info.length > 2)
                                                                        {
                                                                            return <div>
                                                                                {num.numer_pstn} &nbsp; [{num.accountcode}]
                                                                            </div> 
                                                                        }

                                                                        return <div>
                                                                            {num.numer_info} &nbsp; [{num.accountcode}]
                                                                        </div>

                                                                    })
                                                                }
                                                            </td>
                                                            <td className="gocenter">{act}</td>
                                                            
                                                    
                                                        </tr>

                                                } )
                                            }

                                    </tbody>

                            </table>
                    }
                  

               </div>
 
              

                              
        {dialogX}

    </div>
}


export default Itc;